import { Controller, useForm } from 'react-hook-form'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

export default function EmailForm({ onSubmit, finishLogin }) {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm()

  return (
    <Box sx={{ px: 3 }}>
      <form onSubmit={handleSubmit(data => onSubmit(data.email))}>
        <Typography align="center" sx={{ mb: 3 }} variant="h2">
          タイムリーリミット
        </Typography>
        {finishLogin && (
          <Typography sx={{ mb: 2 }} variant="caption" component="p">
            このリンクを受信したメールアドレスを再度入力してログインを完了させてください
          </Typography>
        )}
        <Controller
          name="email"
          control={control}
          rules={{
            required: 'メールアドレスを入力してください',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'メールアドレスの形式で入力してください',
            },
          }}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ mb: 2 }}
              label="メールアドレス"
              placeholder="メールアドレスを入力してください"
              disabled={isSubmitting}
              helperText={errors.email && errors.email.message}
            />
          )}
        />
        <Button
          variant="contained"
          fullWidth
          color="primary"
          size="large"
          style={{ height: 50 }}
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={24} /> : 'ログインまたは新規登録'}
        </Button>
      </form>
    </Box>
  )
}
